import { useMemo } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import SectionContentSide from "./section-content-side";
import IconWithText from "@/components/icon-with-text";
import OutImgSection from "../out-img-section";
import { colors } from "@/utils/const";
import CustomText from "../text";
import { useI18n } from "@/i18n/I18nProvider";

export default function Features({
  section,
  bgHeight = { xs: "70%", md: "40%" },
  id,
}) {
  const { locale } = useI18n();
  const isArabic = locale === "ar";
  const withBg = section?.bgStyle === "split_background";
  const content = useMemo(() => {
    return {
      title: section?.title?.text?.[locale],
      titleType: section?.title?.type,
      subtitle: section?.subtitle?.text?.[locale] || "",
      subtitleType: section?.subtitle?.type,
      description: section?.description?.text?.[locale],
      descType: section?.description?.type,
      imageSrc: section?.img,
      imgAlt: section?.alt,
      note: section?.footer_text.text[locale],
      noteType: section?.footer_text.type,
      iconsWithTexts: section?.items?.map((item) => ({
        icon: item?.icon,
        title: item?.title?.text?.[locale],
        titleType: item?.title?.type,
        desc: item?.description?.text[locale],
        descType: item?.description?.type,
      })),
    };
  }, [locale]);

  if (!content) return null;
  return (
    <Box
      id={id}
      component="section"
      className="horizontal-safe-padding vertical-safe-padding"
      sx={{
        position: "relative",
        overflow: "hidden",
        bgcolor: "transparent",
        "&::before": {
          content: '""',
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          height: !withBg ? "auto" : bgHeight,
          backgroundColor: !withBg ? "#fff" : colors.navy,
          zIndex: 0,
        },
      }}
    >
      <Grid
        container
        spacing={{ xs: 4, md: 1 }}
        alignItems="center"
        sx={{
          flexDirection: {
            xs: "column-reverse",
            md: "row",
          },
          position: "relative",
          zIndex: 1,
        }}
      >
        <Grid item xs={12} md={6}>
          {content.iconsWithTexts && (
            <>
              <SectionContentSide content={content} withBg={withBg} />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  listStyle: "none",
                }}
              >
                {content.iconsWithTexts.map((item, idx) => (
                  <IconWithText key={idx} item={item} />
                ))}
              </Box>
            </>
          )}
          {content.note && (
            <CustomText
              text={content?.note}
              type="xxs"
              customStyle={{
                color: "#000",
                pt: 3,
                fontWeight: "700",
              }}
              variant={content?.noteType}
            />
          )}
        </Grid>
        {content?.imageSrc && (
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: {
                xs: "center",
                md: isArabic ? "flex-start" : "flex-end",
              },
            }}
          >
            <OutImgSection
              img={content?.imageSrc}
              altImg={content?.imgAlt}
              side={isArabic ? "left" : "right"}
              customStyle={{
                width: { xs: "100%", xl: "65%" },
                transform: {
                  lg: isArabic ? "translateX(-18%)" : "translateX(18%) ",
                  xl: isArabic ? "translateX(0%)" : "translateX(0%)",
                },
              }}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
